import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { HomeDashboard } from "~/pages/space/home-dashboard";
import { ScopeType, SpaceOrWorkspaceScope, SpaceScope } from "~/hooks/useScope";
import { setDocumentTitle } from "~/lib/commonUtils";
import { VastEmptyness } from "~/components/vast-emptyness/vast-emptyness";
import { useInventory } from "~/pages/inventory/hooks";
import { AwsGuide } from "~/pages/space/home-dashboard/AwsGuide/AwsGuide";

interface DashboardContentProps {
  scope: SpaceOrWorkspaceScope;
  space: SpaceScope;
}

function DashboardContent({ scope, space }: DashboardContentProps) {
  const { assetsTotalCount, loading } = useInventory({ scope });
  const noData = assetsTotalCount === 0;

  if (noData && !loading && scope.type === ScopeType.Space) {
    const VastEmptynessOptions = {
      id: "overview",
      headline: "WELCOME TO MONDOO",
      tagline:
        "To begin scanning for vulnerabilities, let's integrate your infrastructure with Mondoo.",
      buttonText: "Start Scanning",
      href: `/space/integrations/add?${scope.params}#serverendpointsecurity`,
      buttonText2: "Browse Integrations",
      hrefButton2: `/space/integrations/add?${scope.params}`,
    };

    return <VastEmptyness options={VastEmptynessOptions} />;
  }

  return <HomeDashboard scope={scope} space={space} />;
}

interface SpaceDashboardPageProps {
  space: SpaceScope;
  scope: SpaceOrWorkspaceScope;
}

export function SpaceDashboardPage({ space, scope }: SpaceDashboardPageProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setOpen(Boolean(searchParams.get("guide") === "aws"));
  }, []);

  const handleClose = () => {
    // remove the guide=aws search param upon closing
    searchParams.delete("guide");
    setSearchParams(searchParams);
    setOpen(false);
  };

  setDocumentTitle(scope.name);

  return (
    <>
      <DashboardContent scope={scope} space={space} />
      <AwsGuide scope={scope} open={open} onClose={handleClose} />
    </>
  );
}
